<template>
	<div class="central content flex flex-align-start">
		<div class="flex-1 mr40">
			<el-form ref="form" label-width="90px">
				<el-form-item label="选调类型：">
					<el-radio-group v-model="radio" @change="handleRadioChange">
						<el-radio :label="index" v-for="(item,index) in types" :key="index">{{ item.text }}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<!-- 中央选调开始 -->
			<div v-if="radio == 0">
				<div class="mt20 pointer" v-for="item in zyxdsOtherList" @click="toArticle(item)">
					<div>
						<span class="f16" style="color: #606266;">{{item.title}}</span>
						<span class="float-r" style="color: #999999;">{{item.createDatetime}}</span>
					</div>
					<div class="bor-bottom mt10" style="border-color: #DCDFE6;"></div>
				</div>
				<!-- 分页 -->
				<div class="mt20 flex flex-pack-justify" v-if="zyxdsOtherList.length">
					<div></div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
				</div>
			</div>
			<!-- 中央选调结束 -->

			<!-- 定向选调开始 -->
			<div v-if="radio == 1" class="flex flex-align-center">
				<div style="color: #606266;">省&#12288;&#12288;份：</div>
				<el-select class="ml5" v-model="province" filterable placeholder="请选择" :disabled="!userInfo.vip" :loading="!isReady" @change="chooseProvince">
				    <el-option v-for="(item,index) in provinceList" :key="index" :label="item" :value="item"></el-option>
				</el-select>
			</div>
			<div class="mt20" v-if="radio == 1">
				<div class="mt20 pointer" v-for="item in dxxdsOtherList" @click="toArticle(item)">
					<div>
						<span class="f16" style="color: #606266;">{{item.title}}</span>
						<span class="float-r" style="color: #999999;">{{item.createDatetime}}</span>
					</div>
					<div class="bor-bottom mt10" style="border-color: #DCDFE6;"></div>
				</div>
				<!-- 分页 -->
				<div class="mt20 flex flex-pack-justify" v-if="dxxdsOtherList.length">
					<div></div>
					<el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="page1" :page-sizes="pageSizeArr1" :page-size="page_size1" layout="total, sizes, prev, pager, next, jumper" :total="totalCount1"></el-pagination>
				</div>
			</div>
			<!-- 定向选调结束 -->

			<!-- 常规选调开始 -->
			<div v-if="radio == 2" class="flex flex-align-center">
				<div style="color: #606266;width: 90px;">省&#12288;&#12288;份：</div>
				<el-radio-group style="margin-top: 5px;" v-model="selectedProvince"  @change="chooseProvince2(provinceList2[selectedProvince])">
					<el-radio :label="index" v-for="(item,index) in provinceList2" :key="index">{{ item }}</el-radio>
				</el-radio-group>
			</div>
			<div class="mt20" v-if="radio == 2">
				<div class="mt20 pointer" v-for="item in ptxdsOtherList" @click="toArticle(item)">
					<div>
						<span class="f16" style="color: #606266;">{{item.title}}</span>
						<span class="float-r" style="color: #999999;">{{item.createDatetime}}</span>
					</div>
					<div class="bor-bottom mt10" style="border-color: #DCDFE6;"></div>
				</div>
				<!-- 分页 -->
				<div class="mt20 flex flex-pack-justify" v-if="ptxdsOtherList.length">
					<div></div>
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="page2" :page-sizes="pageSizeArr2" :page-size="page_size2" layout="total, sizes, prev, pager, next, jumper" :total="totalCount2"></el-pagination>
				</div>
			</div>
			<!-- 常规选调结束 -->
		</div>
		
		<!-- 宣传图 -->
		<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
			<el-carousel-item v-for="(item,index) in swiper" :key="index">
				<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Targeted',
	data(){
		return{
			radio: 0,
			types: [
				{ text: '中央选调', type: '0' },
				{ text: '定向选调', type: '1' },
				{ text: '常规选调', type: '2' },
			],
			provinceList: [],
			provinceList2: [],
			province: '',
			province2: '',
			selectedProvince: '',
			form: {
				school: '',
				school1: ''
			},
			loading: false,  // 搜索按钮loading
			
			// 搜索结果
			result: {
				school: '',
				content: '',
				school1: '',
				content1: ''
			},
			zyxdsOtherList: [],
			dxxdsOtherList: [],
			ptxdsOtherList: [],
			page: 1,
			page_size: 10,
			page1: 1,
			page_size1: 10,
			page2: 1,
			page_size2: 10,
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		
		if(this.token) this.getUser()
		
		this.getData()
		this.getProvince()
		this.getProvince2()
	},
	methods: {
		toArticle(item){
			localStorage.setItem('ArticleContent', item.content);
			this.$router.push('/article')
		},
		async getProvince(){
			this.$http.get('/api/webs/search/dxxdsProvince')
			    .then(response => {
			        let res = response.data
					this.isReady = true
					if(res!=null){
						this.provinceList = res.list
					}
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		async getProvince2(){
			this.$http.get('/api/webs/search/ptxdsProvince')
			    .then(response => {
			        let res = response.data
					
					this.isReady = true
					if(res!=null){
						this.provinceList2 = res.list
					}
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		async getData(){
			this.isLoading = true
			let params = {
				pageNum: this.page,
				pageSize: this.page_size
			}
			this.$http.get('/api/webs/search/zyxdsOther', { params })
			.then(response => {
				let res = response.data
				this.isLoading = false
				if(res!=null){
					this.totalCount = res.total
					this.zyxdsOtherList = res.list
				}
			})
			.catch(error => {
				console.error(error)
				this.isLoading = false
			})
		},
		handleSizeChange(val) {
			this.page_size = val
			this.isLoading = true
			this.getData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.isLoading = true
			this.getData()
		},
		// 搜索
		async search(){
			if(!this.token) return EventBus.$emit('show-login', true)
			if(!this.form.school) return this.$message({ message: '请输入学校名称', type: 'warning' })
			this.loading = true
			
			this.$http.get('/api/webs/search/zyxds', { params: { collegeName: this.form.school } })
			.then(response => {
				let res = response.data
				this.loading = false
				
				this.result.school = res.collegeName
				this.result.content = res.describe
			})
			.catch(error => {
				console.error(error)
				this.loading = false
			})
		},
		async handleRadioChange(e){
			if(e==0){
				this.getData()
			}
		},
		async chooseProvince(e){
			this.province = e
			this.isLoading = true
			let params = {
				province: e,
				pageNum: this.page1,
				pageSize: this.page_size1
			}
			this.$http.get('/api/webs/search/dxxdsOther', { params })
			.then(response => {
				let res = response.data
				this.isLoading = false
				this.totalCount1 = res.total
				this.dxxdsOtherList = res.list
			})
			.catch(error => {
				console.error(error)
				this.isLoading = false
			})
		},
		handleSizeChange1(val) {
			this.page_size1 = val
			this.isLoading = true
			this.chooseProvince()
		},
		handleCurrentChange1(val) {
			this.page1 = val
			this.isLoading = true
			this.chooseProvince()
		},
		async chooseProvince2(e){
			this.province2 = e
			this.isLoading = true
			let params = {
				province: e,
				pageNum: this.page2,
				pageSize: this.page_size2
			}
			this.$http.get('/api/webs/search/ptxdsOther', { params })
			.then(response => {
				let res = response.data
				this.isLoading = false
				this.totalCount2 = res.total
				this.ptxdsOtherList = res.list
			})
			.catch(error => {
				console.error(error)
				this.isLoading = false
			})
		},
		handleSizeChange2(val) {
			this.page_size2 = val
			this.isLoading = true
			this.chooseProvince2(this.provinceList2[this.selectedProvince])
		},
		handleCurrentChange2(val) {
			this.page2 = val
			this.isLoading = true
			this.chooseProvince2(this.provinceList2[this.selectedProvince])
		},
	}
}
</script>

<style scoped>
.el-descriptions-item__label.is-bordered-label{
	width: 140px !important;
}
/* 隐藏单选框的圆圈 */
:deep(.el-radio__input) {
  display: none;
}
:deep(.el-radio__label) {
    padding-left: 0px;
}
/* 单选框之间的间距 */
:deep(.el-radio) {
  margin-right: 20px;
}
:deep(.el-form-item__label) {
	text-align: left;
}
</style>